import { ReactNode } from 'react';
import { WithServices } from 'v5/platform/ts/services';
import { WithToastService } from 'v5/services/front/ToastService/ToastService';
import { WithUploadService } from 'v5/services/io/UploadService/UploadService';
import { SingleImageUploader } from './SingleImageUploader';

export type ImageUploadFieldProps = WithServices<
  [WithUploadService, WithToastService]
> & {
  /** Public URL of the uploaded image; `null` = none. */
  value: string | null;
  onChange(value: string | null): void;
  /** Lets the host hold its steps and its save while an upload runs. */
  onUploadingChange?(uploading: boolean): void;
  /** Content of the empty tile (e.g. initials); an image icon by default. */
  placeholder?: ReactNode;
  /** `contain` keeps a logo whole instead of cropping it to the square tile. */
  imageFit?: 'cover' | 'contain';
  disabled?: boolean;
  className?: string;
};

/** A single image kept by its public URL (`SingleImageUploader`). */
export function ImageUploadField({
  value,
  onChange,
  ...rest
}: ImageUploadFieldProps) {
  return (
    <SingleImageUploader
      {...rest}
      imageUrl={value}
      onUploaded={media => {
        onChange(media.accessUrl);
        // The URL is all this field keeps; the tile loads it from now on.
        if (media.previewUrl) URL.revokeObjectURL(media.previewUrl);
      }}
      onRemove={() => onChange(null)}
    />
  );
}
